import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { Gallery, Item } from "react-photoswipe-gallery";
import { BaseURL, Property } from "../../APIs/APIUrls";
import { isArray } from "chart.js/helpers";
import { useEffect } from "react";
import React from "react";
import { GetAllPropertyforWeb } from "../../APIs/APIHelperforWeb";
import { useSnackbar } from "notistack";
import { useNavigate, useParams } from "react-router-dom";


export default function Slider2({ setMetaImage }) {

  const { title } = useParams();

  const [propertyImages, setPropertyImages] = React.useState([]);

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [AllProperties, setAllProperties] = React.useState([]);
  const [PropertyObject, setPropertyObject] = React.useState({});

  useEffect(() => {

    if (!title) {
      enqueueSnackbar("Property title is missing in the URL", { variant: "error" });
      navigate("/allproperties");
      return;
    }

    const properties = JSON.parse(localStorage.getItem("AllPropertiesforWeb")) || [];

    const loadProperties = async () => {
      const data = properties.length === 0 ? await GetAllPropertyforWeb() : properties;
      if (properties.length === 0) {
        localStorage.setItem("AllPropertiesforWeb", JSON.stringify(data));
      }

      setAllProperties(data);
      const property = data.find((prop) => prop.AutoGeneratedURL === title);
      if (!property) {
        enqueueSnackbar("Property not found", { variant: "error" });
        navigate("/allproperties");
        return;
      }
      setPropertyObject(isArray(property) ? property[0] : property);


    
      if (Array.isArray(property._lstPropertyImages)) {
        const mainImage =
          property._lstPropertyImages.find((img) => img?.IsCard !== true) ||
          property._lstPropertyImages[0];

        if (mainImage?.ImageURL) {
          setMetaImage?.(BaseURL + mainImage.ImageURL);
        }
      }

    };

    loadProperties();
  }, []);


  useEffect(() => {

    if (isArray(PropertyObject._lstPropertyImages)) {
      const images = PropertyObject._lstPropertyImages.filter(x => x.IsCard != true).map((img) => ({
        src: BaseURL + img.ImageURL,
        alt: PropertyObject.PropertyTitle
      }));
      setPropertyImages(images);
    }



  }, [PropertyObject])

  return (
    <section className="flat-slider-detail-v2 flat-slider-wrap">
      <Gallery>
        <Swiper
          modules={[Pagination, Navigation]}
          pagination={{ clickable: true, el: ".spb19" }}
          className="swiper tf-sw-location"
          navigation={{
            prevEl: ".pnbp1",
            nextEl: ".pnbn1",
          }}
        >
          {propertyImages.map((image, index) => (
            <SwiperSlide key={index}>
              <Item
                original={image.src}
                thumbnail={image.src}
                width={1920}
                height={701}
              >
                {({ ref, open }) => (
                  <a
                    data-fancybox="gallery"
                    onClick={open}
                    className="box-img-detail d-block"
                  >
                    <img
                      ref={ref}
                      alt={image.alt}
                      src={image.src}
                      width={1920}
                      height={701}
                    />
                  </a>
                )}
              </Item>
            </SwiperSlide>
          ))}
          <div className="box-navigation">
            <div className="navigation swiper-nav-next nav-next-location pnbp1">
              <span className="icon icon-arr-l" />
            </div>
            <div className="navigation swiper-nav-prev nav-prev-location pnbn1">
              <span className="icon icon-arr-r" />
            </div>
          </div>
          <div className="sw-pagination spb19 sw-pagination-location text-center" />
        </Swiper>{" "}
      </Gallery>
    </section>
  );
}
